// Metaobject-based Bundle System for Product Detail Page
var option_data_fields_arr = [];
var option_data_fields = [];

// Performance optimization objects for metaobject-based bundles
window.OptimizedBundleManager = window.OptimizedBundleManager || {
    // Optimized batch cart addition for metaobject bundles
    async batchAddToCart(cartItems) {
        const startTime = performance.now();
        
        // Filter out items that have already failed to prevent infinite loops
        const filteredItems = cartItems.filter(item => {
            const itemKey = `${item.id}_${item.properties?._boldBuilderId || 'none'}`;
            return !window.failedCartItems || !window.failedCartItems.has(itemKey);
        });
        
        if (filteredItems.length === 0) {
            console.warn('All metaobject bundle items have previously failed, skipping to prevent infinite loop');
            return { success: false, error: 'All items previously failed' };
        }
        
        try {
            // Use Shopify's batch add endpoint
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ items: filteredItems })
            });

            const endTime = performance.now();
            const duration = endTime - startTime;

            if (!response.ok) {
                // Mark these items as failed to prevent infinite retry
                if (window.failedCartItems) {
                    filteredItems.forEach(item => {
                        const itemKey = `${item.id}_${item.properties?._boldBuilderId || 'none'}`;
                        window.failedCartItems.add(itemKey);
                    });
                }
                
                throw new Error(`Batch add failed: ${response.status}`);
            }

            const result = await response.json();
            
            // Clear failed items on success
            if (window.failedCartItems) {
                filteredItems.forEach(item => {
                    const itemKey = `${item.id}_${item.properties?._boldBuilderId || 'none'}`;
                    window.failedCartItems.delete(itemKey);
                });
            }
            
            // Track performance
            if (window.BundlePerformanceMonitor) {
                window.BundlePerformanceMonitor.trackOperation('batchAddToCart', duration, true, {
                    itemCount: filteredItems.length,
                    source: 'metaobject'
                });
            }

            console.log(`Successfully added ${filteredItems.length} bundle items in ${duration.toFixed(2)}ms`);
            
            return { success: true, result: result, duration: duration };
            
        } catch (error) {
            const endTime = performance.now();
            const duration = endTime - startTime;
            
            // Track failed performance
            if (window.BundlePerformanceMonitor) {
                window.BundlePerformanceMonitor.trackOperation('batchAddToCart', duration, false, {
                    itemCount: cartItems.length,
                    error: error.message,
                    source: 'metaobject'
                });
            }

            console.error('OptimizedBundleManager batch add failed:', error);
            return { success: false, error: error, duration: duration };
        }
    },

    // Add bundle to cart with parent item
    async addBundleToCart(formData, parentResponse) {
        const bundleVariantIds = formData.get('properties[_boldVariantIds]');
        const bundleVariantQtys = formData.get('properties[_boldVariantQtys]');
        const bundleBuilderId = formData.get('properties[_boldBuilderId]');
        const bundleProductIds = formData.get('properties[_boldProductIds]');
        const bundleVariantNames = formData.get('properties[_boldVariantNames]');

        if (!bundleVariantIds || !bundleVariantQtys || !bundleBuilderId) {
            return { success: false, error: 'Missing bundle data' };
        }

        const variantIds = bundleVariantIds.split(',').map(id => id.trim());
        const quantities = bundleVariantQtys.split(',').map(qty => parseInt(qty.trim()) || 1);
        const productIds = bundleProductIds ? bundleProductIds.split(',').map(id => id.trim()) : [];
        const variantNames = bundleVariantNames ? bundleVariantNames.split(',').map(name => name.trim()) : [];

        const cartItems = variantIds.map((variantId, index) => ({
            id: parseInt(variantId),
            quantity: quantities[index],
            properties: {
                '_boldBuilderId': bundleBuilderId,
                '_boldIsChildItem': 'true',
                '_boldVariantName': variantNames[index] || '',
                '_boldProductId': productIds[index] || '',
                '_bundleSource': 'metaobject'
            }
        }));

        return await this.batchAddToCart(cartItems);
    }
};

window.BundlePreloader = window.BundlePreloader || {
    preloadedData: new Map(),
    
    // Get bundle data instantly from preloaded cache (updated for metafield approach)
    getBundleData(productId) {
        const data = this.preloadedData.get(productId) || 
                     window.bundleMetaobjectData?.[productId] ||
                     window.collectionBundleData?.[productId] ||
                     window.searchBundleData?.[productId];
        
        if (data) {
            console.log('Bundle data retrieved for product:', productId, 'Source: metafield-based');
            console.log('Bundle metaobject ID:', data.bundle_metaobject_id);
        }
        
        return data;
    },
    
    // Preload bundle data for faster access
    preloadBundleData(productId, data) {
        this.preloadedData.set(productId, data);
        console.log('Bundle data preloaded for product:', productId, 'Metaobject ID:', data.bundle_metaobject_id);
    }
};

window.BundlePerformanceMonitor = window.BundlePerformanceMonitor || {
    operations: [],
    
    // Track bundle operation performance
    trackOperation(name, duration, success, metadata = {}) {
        const operation = {
            name,
            duration,
            success,
            metadata,
            timestamp: Date.now()
        };
        
        this.operations.push(operation);
        
        // Keep only last 100 operations
        if (this.operations.length > 100) {
            this.operations = this.operations.slice(-100);
        }
        
        // Log slow operations
        if (duration > 1000) {
            console.warn(`Slow bundle operation: ${name} took ${duration.toFixed(2)}ms`, metadata);
        }
    },
    
    // Get performance statistics
    getStats() {
        const successful = this.operations.filter(op => op.success);
        const failed = this.operations.filter(op => !op.success);
        
        return {
            total: this.operations.length,
            successful: successful.length,
            failed: failed.length,
            averageDuration: successful.reduce((sum, op) => sum + op.duration, 0) / successful.length || 0,
            slowestOperation: this.operations.reduce((slowest, op) => 
                op.duration > (slowest?.duration || 0) ? op : slowest, null)
        };
    }
};

// Handle bundle choose button clicks
document.addEventListener("click", function (event) {
    if (event.target.matches("#bundle-choose")) {
        event.target.classList.add("hide-bundle-choose");

        var form = event.target.closest("form");
        form.querySelector(".bold_option_set").classList.remove("hide-bundle-choose");
        form.querySelector(".buddle-atc-btn").classList.remove("hide-bundle-choose");
    }
});
    
// Debug function to inspect bundle data structure
window.debugBundleData = function() {
    console.log('=== Bundle Data Debug Info ===');
    console.log('Available bundle data:', window.bundleMetaobjectData);
    
    if (window.bundleMetaobjectData) {
        Object.keys(window.bundleMetaobjectData).forEach(productId => {
            const data = window.bundleMetaobjectData[productId];
            console.log(`Product ${productId}:`, {
                bundle_name: data.bundle_name,
                bundle_metaobject_id: data.bundle_metaobject_id,
                main_product_id: data.product,
                main_product_title: data.main_product_title,
                options_count: data.bundle_options?.[0]?.options?.length || 0
            });
        });
    }
    
    const currentProduct = document.querySelector('.cc-main-product.product-main .product-info');
    if (currentProduct) {
        const productId = currentProduct.getAttribute('attr-prod-id');
        console.log('Current product ID:', productId);
        console.log('Bundle data for current product:', window.bundleMetaobjectData?.[productId]);
    }
    console.log('=== End Debug Info ===');
};

// Initialize metaobject-based bundle system (Updated for metafield approach)
document.addEventListener('DOMContentLoaded', function() {
    console.log('Initializing metaobject bundle system with metafield approach...');
    
    // Add debug info to window for easy access
    if (typeof window !== 'undefined') {
        console.log('Debug function available: Call window.debugBundleData() to inspect bundle data');
    }
    
    initializeMetaobjectBundleSystem();
});

/**
 * Clean option name by removing identifier suffix (e.g., "| EK244M")
 * @param {string} optionName - Original option name (e.g., "Piston Ring Set | EK244")
 * @returns {string} Cleaned option name (e.g., "Piston Ring Set")
 */
function cleanOptionName(optionName) {
    if (!optionName) return optionName;
    return optionName.split('|')[0].trim();
}

/**
 * Convert string to handleized format for property names
 * @param {string} name - Name to handleize
 * @returns {string} Handleized name (e.g., "piston-ring-set")
 */
function handleize(name) {
    return name
        .toLowerCase()                   // Convert to lowercase
        .replace(/\s+/g, '-')           // Replace spaces with hyphens
        .replace(/[^\w\-]+/g, '')       // Remove all non-word chars except hyphens
        .replace(/\-\-+/g, '-')         // Replace multiple hyphens with single
        .replace(/^-+/, '')             // Trim hyphens from start
        .replace(/-+$/, '');            // Trim hyphens from end
}

function initializeMetaobjectBundleSystem() {
const bundleStock = document.querySelector(".bundle_stock");

if (document.querySelector(".product-main") && bundleStock && bundleStock.value == "instock") {
    if (!document.querySelector('.cc-main-product.product-main .product-info .out-of-stock-button')) {
        var parent_bundle_id = document.querySelector(".cc-main-product.product-main .product-info").getAttribute("attr-prod-id");

        document.querySelector('#addToCartBtn').setAttribute("disabled", "disabled");

            // Get bundle data from metaobject using new metafield approach
            const bundleData = window.bundleMetaobjectData && window.bundleMetaobjectData[parent_bundle_id];
            
            if (bundleData) {
                console.log('Bundle data found via metafield for product:', parent_bundle_id, bundleData);
                console.log('Bundle metaobject ID:', bundleData.bundle_metaobject_id);
                console.log('Main product title:', bundleData.main_product_title);
                processMetaobjectBundleData(bundleData, parent_bundle_id);
            } else {
                console.warn('No bundle data found for product:', parent_bundle_id);
                console.log('Available bundle data keys:', Object.keys(window.bundleMetaobjectData || {}));
                // Enable add to cart button if no bundle data
                const addToCartBtn = document.querySelector('#addToCartBtn');
                if (addToCartBtn) addToCartBtn.removeAttribute("disabled");
            }
        }
    }
}

function processMetaobjectBundleData(data, parent_bundle_id) {
                console.log('Processing metaobject bundle data:', data);
                console.log('Bundle metaobject ID:', data.bundle_metaobject_id);
                console.log('Main product ID:', data.product);
                console.log('Main product title:', data.main_product_title);
                
                var option_set = "";
                option_set += '<div class="bold_option_set hide-bundle-choose">';
                var options = '';
                var shop_product_id = parseInt(parent_bundle_id);
                option_data_fields_arr[shop_product_id] = data;

    if (data && data.bundle_options && data.bundle_options[0] && data.bundle_options[0].options) {
        var options_data = data.bundle_options[0].options;
                    var name_attributes = [];
                    var product_attributes = [];
                    var varient_attributes = [];
                    var price_attributes = [];
                    var qty_attributes = [];
                    var product_features_html = "";

                    for (var b = 0; b < options_data.length; b++) {
            var option = options_data[b];
                        console.log('Processing option:', option.bundle_option_name, 'Metaobject ID:', option.bundle_option_metaobject_id);
                        var required_type = "";
            if (option.is_required == 1) {
                            required_type = "required";
                        }

            if (option.options_values && option.options_values.length > 1) {
                // Multiple variants - show as dropdown
                const cleanedOptionName = cleanOptionName(option.bundle_option_name);
                const handleizeName = handleize(cleanedOptionName);
                options += '<div class="bold_option bold_option_dropdown 15 ' + handleizeName + '"><label>';
                options += '<span class="bold_option_title">' + cleanedOptionName + '</span>';
                options += '<span class="bold_option_element"><select id="dd_select_' + b + '" attr-name="' + cleanedOptionName + '" name="properties[' + cleanedOptionName + ']" data-original-name="' + option.bundle_option_name + '" data-bundle-option-id="' + (option.bundle_option_id || '') + '" class="bundle_option_select" ' + required_type + '>';
                
                // Add default option
                options += '<option value="">-- Choose ' + cleanOptionName(option.bundle_option_name) + ' --</option>';
                
                // Add variant options
                for (var v = 0; v < option.options_values.length; v++) {
                    var variant = option.options_values[v];
                    if (variant.available !== false) {
                        var selected = (variant.is_default == 1) ? 'selected' : '';
                        var variantQty = (variant.qty != null && variant.qty !== '') ? String(variant.qty) : '1';
                        options += '<option value="' + variant.option_value + '" data-option_value_key="' + v + '" data-variant-id="' + variant.varient_id + '" data-product-id="' + variant.product_id + '" data-price="' + variant.price + '" data-qty="' + variantQty + '" data-original-value="' + variant.option_value + '" ' + selected + '>' + cleanOptionName(variant.option_value) + '</option>';
                    }
                }
                
                options += '</select></span></label></div>';
            } else if (option.options_values && option.options_values.length === 1) {
                // Single variant - create dropdown (visible or hidden based on option type)
                var variant = option.options_values[0];
                if (variant.available !== false) {
                    const cleanedOptionName = cleanOptionName(option.bundle_option_name);
                    const handleizeName = handleize(cleanedOptionName);
                    const required_type = (option.is_required == 1) ? "required" : "";
                    
                    // Define which single-variant options should be visible
                    const visibleSingleVariantOptions = [
                        'Piston Set', 'Piston Ring Set', 'Main Bearing Set', 'Rod Bearing Set'
                    ];
                    
                    const shouldBeVisible = visibleSingleVariantOptions.some(visibleOption => 
                        cleanedOptionName.toLowerCase().includes(visibleOption.toLowerCase())
                    );
                    
                    var variantQty = (variant.qty != null && variant.qty !== '') ? String(variant.qty) : '1';
                    if (shouldBeVisible) {
                        // Create visible dropdown for important single-variant options
                        options += '<div class="bold_option bold_option_dropdown 15 ' + handleizeName + '"><label>';
                        options += '<span class="bold_option_title">' + cleanedOptionName + '</span>';
                        options += '<span class="bold_option_element"><select id="dd_select_' + b + '" attr-name="' + cleanedOptionName + '" name="properties[' + cleanedOptionName + ']" data-original-name="' + option.bundle_option_name + '" data-bundle-option-id="' + (option.bundle_option_id || '') + '" class="bundle_option_select" ' + required_type + '>';
                        options += '<option value="">-- Choose ' + cleanOptionName(option.bundle_option_name) + ' --</option>';
                        options += '<option value="' + variant.option_value + '" data-option_value_key="0" data-variant-id="' + variant.varient_id + '" data-product-id="' + variant.product_id + '" data-price="' + variant.price + '" data-qty="' + variantQty + '" data-original-value="' + variant.option_value + '" selected>' + cleanOptionName(variant.option_value) + '</option>';
                        options += '</select></span></label></div>';
                    } else {
                        // Create hidden dropdown for other single-variant options (like reference side)
                        options += '<div class="bold_option bold_option_dropdown 17" style="display: none;"><label>';
                        options += '<span class="bold_option_title">' + cleanedOptionName + '</span>';
                        options += '<span class="bold_option_element"><select id="dd_select_' + b + '" style="display: none;" name="properties[' + cleanedOptionName + ']" data-original-name="' + option.bundle_option_name + '" data-bundle-option-id="' + (option.bundle_option_id || '') + '" class="bundle_option_select" ' + required_type + '>';
                        options += '<option value="">-- Choose ' + cleanOptionName(option.bundle_option_name) + ' --</option>';
                        options += '<option value="' + variant.option_value + '" data-option_value_key="0" data-variant-id="' + variant.varient_id + '" data-product-id="' + variant.product_id + '" data-price="' + variant.price + '" data-qty="' + variantQty + '" data-original-value="' + variant.option_value + '" selected>' + cleanOptionName(variant.option_value) + '</option>';
                        options += '</select></span></label></div>';
                        
                        // Add to initial attributes for hidden single-variant options
                        name_attributes.push(variant.option_value);
                        product_attributes.push(variant.product_id);
                        varient_attributes.push(variant.varient_id);
                        qty_attributes.push(variant.qty || '1');
                        shop_product_id += parseInt(variant.varient_id);
                        price_attributes.push(variant.price.toString().replace(".", ""));
                        product_features_html += "<li>" + cleanOptionName(variant.option_value) + "</li>";
                    }
                }
            }
        }
        
        // Generate bundle attributes strings
                    if (name_attributes.length > 0) {
                        name_attributes = name_attributes.join(",").trim();
                    }
                    if (product_attributes.length > 0) {
                        product_attributes = product_attributes.join(",").trim();
                    }
                    if (varient_attributes.length > 0) {
                        varient_attributes = varient_attributes.join(",").trim();
                    }
                    if (qty_attributes.length > 0) {
                        qty_attributes = qty_attributes.join(",").trim();
                    }
                    if (price_attributes.length > 0) {
            price_attributes = price_attributes.join(",").trim().replace(".", "");
                    }
                
                    if (options != "") {
                        option_set += options;
                    }
        
        var total_html = '<div class="bold_option_total">' +
            '<input type="hidden" name="properties[_boldVariantNames]" data-property-name="_boldVariantNames" value="' + name_attributes + '">' +
            '<input type="hidden" name="properties[_boldVariantIds]" data-property-name="_boldVariantIds" value="' + varient_attributes + '">' +
            '<input type="hidden" name="properties[_boldProductIds]" data-property-name="_boldProductIds" value="' + product_attributes + '">' +
            '<input type="hidden" name="properties[_boldVariantPrices]" data-property-name="_boldVariantPrices" value="0">' +
            '<input type="hidden" name="properties[_boldVariantQtys]" data-property-name="_boldVariantQtys" value="' + qty_attributes + '">' +
            '<input type="hidden" name="properties[_boldBuilderId]" data-property-name="_boldBuilderId" value="' + shop_product_id + '">' +
            '</div>';
                    option_set += total_html + '</div>';
                }

    // Inject bundle options into the product form
    let productCard = document.querySelector(`.product-info[attr-prod-id="${parent_bundle_id}"]`);
                if (productCard) {
        productCard.querySelector(".product-info__add-to-cart").insertAdjacentHTML("beforeBegin", option_set);

                    var addToCartButton = productCard.querySelector("#addToCartBtn");
                    if (addToCartButton) {
                        addToCartButton.removeAttribute("disabled");
                    }

                    var bundleChooseButton = productCard.querySelector("#bundle-choose");
                    if (bundleChooseButton) {
                        bundleChooseButton.removeAttribute("disabled");
                    }
    }
}


// Add to Cart button validation for bundle products (only on click)
const ProductATCbuttons = document.querySelectorAll('#addToCartBtn');

ProductATCbuttons.forEach((button) => {
    button.addEventListener('click', () => {
        const bundleOptions = document.querySelector('.bold_option_set');
        if (!bundleOptions) {
            return; // No bundle options, allow normal submission
        }

        let isBlank = false;
        const dropdownItems = bundleOptions.querySelectorAll('.bold_option_dropdown select');

        // Clear existing errors and borders first
        const existingErrors = bundleOptions.querySelectorAll('.required-error');
        existingErrors.forEach(error => error.remove());

        dropdownItems.forEach((item) => {
            item.classList.remove('required-border'); // Remove any existing borders
            if (item.value === '') {
                isBlank = true;
                item.classList.add('required-border');
            }
        });

        if (isBlank) {
            // Only show error when user clicks and validation fails
            const errorMessage = document.createElement('p');
            errorMessage.classList.add('required-error');
            errorMessage.textContent = 'Please select an option';
            bundleOptions.prepend(errorMessage);
        }
    });
});

// Real-time validation function for product page
function validateBundleOptionsRealTime() {
    const bundleOptions = document.querySelector('.bold_option_set');
    if (!bundleOptions) return;

    const dropdownItems = bundleOptions.querySelectorAll('.bold_option_dropdown select');
    if (dropdownItems.length === 0) return;

    // Check if all required visible options are selected (ignore hidden single-variant dropdowns)
    const visibleSelects = Array.from(dropdownItems).filter(select => {
        const parentDiv = select.closest('.bold_option');
        return parentDiv && parentDiv.style.display !== 'none';
    });
    
    // For visible single-variant options that should be required, check if they're selected
    const allSelected = visibleSelects.every(select => {
        // If it's a visible single-variant option with only one choice, it should be auto-selected
        const allOptions = Array.from(select.querySelectorAll('option'));
        const nonEmptyOptions = allOptions.filter(option => option.value.trim() !== '');
        
        if (nonEmptyOptions.length === 1) {
            // Auto-select the single option if not already selected
            if (select.value.trim() === '') {
                select.value = nonEmptyOptions[0].value;
            }
            return true; // Single option is considered valid
        }
        return select.value.trim() !== '';
    });

    if (allSelected) {
        // All options selected - clear any existing error messages
        const existingErrors = bundleOptions.querySelectorAll('.required-error');
        existingErrors.forEach(error => error.remove());
        
        // Remove red border styling from all visible selects
        visibleSelects.forEach(select => select.classList.remove('required-border'));
        
        console.log('Product page bundle: All visible options selected, errors cleared');
    } else {
        // Not all visible options selected - add red border to empty visible selects (but don't show error message yet)
        visibleSelects.forEach(select => {
            if (select.value.trim() === '') {
                select.classList.add('required-border');
            } else {
                select.classList.remove('required-border');
            }
        });
    }
}

// Handle bundle option changes (consolidated handler)
document.addEventListener("change", (event) => {
    if(!document.querySelector(".cc-main-product")){
        return;
    }
    if (event.target.matches("select.bundle_option_select")) {
        const attrElement = event.target;
        const attrName = attrElement.getAttribute("attr-name");

        // Special handling for Piston Set -> Piston Ring Set (auto-suggestion)
        if (attrName === "Piston Set") {
            let pistonSet = attrElement.value;
            
            if (pistonSet && pistonSet !== "") {
                const pistonRingSetElement = document.querySelector('.bold_option_element select[attr-name="Piston Ring Set"]');
                if (pistonRingSetElement) {
                    // Convert "Piston Set" option to corresponding "Piston Ring Set" option
                    let pistonRingSet = pistonSet.replace("Piston Set", "Piston Ring Set");
                    
                    // Check if the corresponding option exists in Piston Ring Set dropdown
                    const optionExists = Array.from(pistonRingSetElement.options).some(opt => opt.value === pistonRingSet);
                    if (optionExists) {
                        // Only update if it's different from current selection
                        if (pistonRingSetElement.value !== pistonRingSet) {
                            pistonRingSetElement.value = pistonRingSet;
                            
                            // Add a visual indicator that this was auto-selected
                            pistonRingSetElement.style.backgroundColor = '#f0f8ff';
                            setTimeout(() => {
                                pistonRingSetElement.style.backgroundColor = '';
                            }, 2000);
                            
                            // Trigger change event to update hidden fields
                            pistonRingSetElement.dispatchEvent(new Event('change', { bubbles: true }));
                            
                            console.log(`Auto-selected "${pistonRingSet}" based on "${pistonSet}" selection`);
                        }
                    } else {
                        console.log(`No matching Piston Ring Set option found for "${pistonSet}"`);
                        // Reset Piston Ring Set to empty if no matching option exists
                        if (pistonRingSetElement.value !== "") {
                            pistonRingSetElement.value = "";
                            pistonRingSetElement.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    }
                }
            } else {
                // If Piston Set is cleared, also clear Piston Ring Set
                const pistonRingSetElement = document.querySelector('.bold_option_element select[attr-name="Piston Ring Set"]');
                if (pistonRingSetElement && pistonRingSetElement.value !== "") {
                    pistonRingSetElement.value = "";
                    pistonRingSetElement.dispatchEvent(new Event('change', { bubbles: true }));
                    console.log('Cleared Piston Ring Set because Piston Set was cleared');
                }
            }
        }

        // Update bundle hidden fields when options change
        updateBundleHiddenFields();
        
        // Smart validation: Clear errors when all options are selected
        validateBundleOptionsRealTime();
    }
});

function updateBundleHiddenFields() {
    const productInfo = document.querySelector(".cc-main-product.product-main .product-info");
    if (!productInfo) return;
    
    const parentBundleId = productInfo.getAttribute("attr-prod-id");
    const bundleData = option_data_fields_arr[parentBundleId];
    
    if (!bundleData || !bundleData.bundle_options || !bundleData.bundle_options[0]) return;
    
    const optionsData = bundleData.bundle_options[0].options;
    let shopProductId = parseInt(parentBundleId);
    
    let nameAttributes = [];
    let productAttributes = [];
    let varientAttributes = [];
    let qtyAttributes = [];
    let priceAttributes = [];
    let productFeaturesHtml = "";

    // Process each select element
    document.querySelectorAll(".bold_option_element select").forEach((selectElement, index) => {
        const selectedOption = selectElement.options[selectElement.selectedIndex];
        
        if (selectedOption && selectedOption.value) {
            const variantId = selectedOption.getAttribute('data-variant-id');
            const productId = selectedOption.getAttribute('data-product-id');
            const price = selectedOption.getAttribute('data-price');
            
            if (variantId && productId) {
                var qty = selectedOption.getAttribute('data-qty') || '1';
                productFeaturesHtml += "<li>" + selectedOption.value + "</li>";
                nameAttributes.push(selectedOption.value);
                productAttributes.push(productId);
                varientAttributes.push(variantId);
                qtyAttributes.push(qty);
                shopProductId += parseInt(variantId);
                priceAttributes.push(price ? price.toString().replace(".", "") : "0");
            }
        }
    });

    // Process hidden inputs (for single variant options)
    document.querySelectorAll('input[type="hidden"][data-variant-id]').forEach((hiddenInput) => {
        const variantId = hiddenInput.getAttribute('data-variant-id');
        const productId = hiddenInput.getAttribute('data-product-id');
        const price = hiddenInput.getAttribute('data-price');
        const qty = hiddenInput.getAttribute('data-qty') || '1';
        
        if (variantId && productId) {
            productFeaturesHtml += "<li>" + hiddenInput.value + "</li>";
            nameAttributes.push(hiddenInput.value);
            productAttributes.push(productId);
            varientAttributes.push(variantId);
            qtyAttributes.push(qty);
            shopProductId += parseInt(variantId);
            priceAttributes.push(price ? price.toString().replace(".", "") : "0");
        }
    });

    // Join arrays
    const nameAttributesStr = nameAttributes.length > 0 ? nameAttributes.join(",").trim() : "";
    const productAttributesStr = productAttributes.length > 0 ? productAttributes.join(",").trim() : "";
    const varientAttributesStr = varientAttributes.length > 0 ? varientAttributes.join(",").trim() : "";
    const qtyAttributesStr = qtyAttributes.length > 0 ? qtyAttributes.join(",").trim() : "";
    const priceAttributesStr = priceAttributes.length > 0 ? priceAttributes.join(",").trim().replace(".", "") : "";

    // Update hidden fields
    const boldOptionTotal = document.querySelector(".bold_option_total");
    if (boldOptionTotal) {
        const totalHtml = `
            <input type="hidden" name="properties[_boldVariantNames]" data-property-name="_boldVariantNames" value="${nameAttributesStr}">
            <input type="hidden" name="properties[_boldVariantIds]" data-property-name="_boldVariantIds" value="${varientAttributesStr}">
            <input type="hidden" name="properties[_boldProductIds]" data-property-name="_boldProductIds" value="${productAttributesStr}">
            <input type="hidden" name="properties[_boldVariantPrices]" data-property-name="_boldVariantPrices" value="0">
            <input type="hidden" name="properties[_boldVariantQtys]" data-property-name="_boldVariantQtys" value="${qtyAttributesStr}">
            <input type="hidden" name="properties[_boldBuilderId]" data-property-name="_boldBuilderId" value="${shopProductId}">
        `;
        boldOptionTotal.innerHTML = totalHtml;
    }

    // Update product features list
    const productFeaturesList = document.querySelector(".product-features ul");
    if (productFeaturesList) {
        productFeaturesList.innerHTML = productFeaturesHtml;
    }
}